import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const KakaotalkIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M10.9167 9.77776C10.8333 9.55554 10.6111 9.33332 10.3056 9.30554C10 9.30554 9.75001 9.55554 9.69445 9.77776L8.58334 12.7222C8.44445 13.1667 8.58334 13.3333 8.69445 13.3889C8.77779 13.4444 8.8889 13.4444 9.00001 13.4444C9.19445 13.4444 9.33334 13.3611 9.3889 13.25L9.61112 12.6389H11.0278L11.25 13.25C11.3056 13.3889 11.4445 13.4444 11.6389 13.4444C11.75 13.4444 11.8333 13.4444 11.9445 13.3889C12.0833 13.3333 12.1945 13.1667 12.0556 12.7222L10.9445 9.77776H10.9167ZM9.80556 11.8055L10.2778 10.4722L10.75 11.8055H9.80556Z"
        fill={color}
      />
      <path
        d="M20.4444 2H3.55556C2.69444 2 2 2.69444 2 3.55556V20.4167C2 21.2778 2.69444 21.9722 3.55556 21.9722H20.4444C21.3056 21.9722 22 21.2778 22 20.4167V3.55556C22 2.69444 21.3056 2 20.4444 2ZM12 17.6111C11.5 17.6111 11.0278 17.5833 10.5556 17.5C10.0833 17.8333 7.38889 19.7222 7.11111 19.7778C7.11111 19.7778 7 19.8056 6.91667 19.7778C6.83333 19.7222 6.83333 19.5833 6.83333 19.5833C6.83333 19.3889 7.52778 17.0556 7.66667 16.6389C5.38889 15.5 3.86111 13.5 3.86111 11.2222C3.86111 7.69445 7.5 4.80556 11.9722 4.80556C16.4444 4.80556 20.0833 7.66667 20.0833 11.2222C20.0833 14.7778 16.4444 17.6389 11.9722 17.6389L12 17.6111Z"
        fill={color}
      />
      <path
        d="M9.1389 9.80554C9.1389 9.55554 8.97223 9.33332 8.72223 9.30554H6.33334C6.11112 9.30554 5.91668 9.49999 5.91668 9.72221C5.91668 9.97221 6.08334 10.1944 6.33334 10.2222H7.05557V13C7.05557 13.25 7.27779 13.4444 7.52779 13.4444C7.77779 13.4444 8.00001 13.25 8.00001 13V10.2222H8.72223C8.94445 10.2222 9.1389 10.0278 9.1389 9.80554Z"
        fill={color}
      />
      <path
        d="M14.2778 12.5278H13.2778V9.77776C13.2778 9.52776 13.0556 9.30554 12.8056 9.30554C12.5556 9.30554 12.3333 9.52776 12.3333 9.77776V12.9722C12.3333 13.2222 12.5278 13.4167 12.7778 13.3889H14.2778C14.5278 13.3889 14.7222 13.1944 14.7222 12.9722C14.7222 12.7222 14.5278 12.5555 14.2778 12.5555V12.5278Z"
        fill={color}
      />
      <path
        d="M17.8611 12.6945L16.6945 11.1667L17.75 10.1111C17.8333 10.0278 17.8611 9.94448 17.8611 9.83337C17.8611 9.72226 17.8056 9.61115 17.7222 9.52781C17.6389 9.44448 17.5278 9.38892 17.3889 9.38892C17.3056 9.38892 17.1945 9.4167 17.1389 9.50003L15.8333 10.8056V9.80559C15.8333 9.55559 15.6389 9.36115 15.3889 9.36115C15.1389 9.36115 14.9167 9.55559 14.8889 9.80559V13C14.8889 13.25 15.1111 13.4723 15.3611 13.4723C15.6111 13.4723 15.8333 13.25 15.8333 13V11.9723L16 11.8056L17.1111 13.25C17.1945 13.3611 17.3333 13.4445 17.5 13.4445C17.6111 13.4445 17.6945 13.4167 17.7778 13.3611C17.8889 13.2778 17.9445 13.1667 17.9722 13.0556C17.9722 12.9445 17.9722 12.8056 17.8889 12.6945H17.8611Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

KakaotalkIcon.displayName = 'KakaotalkIcon';
